<div class="relativePageContainer">
  <div #pageContainer class="page-container">
    <div [ngClass]="isDrawerOpen? '' : 'noShadowOverlay'" class="dx-card">
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [(opened)]="isDrawerOpen"
        [className]="'drawerParent'"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'expand'"
        [shading]="isEditMode"
        template="template">

        <!---------------------->
        <!--  Drawer content  -->
        <!---------------------->

        <div *dxTemplate="let data of 'template'" [style.width.px]="(document.documentElement.clientWidth - 20) * 0.8"
             class="drawerInnerContent flexColumn" style="border-radius: 10px; gap: 0;">

          <div class="drawerTitleWrapper">
            <h2 *ngIf="!isNewReport && !!reportTitle" class="partitionName">{{ reportTitle }}</h2>
            <h2 *ngIf="isNewReport" class="partitionName">{{ 'DASHBOARD.REPORTS.ADD_REPORT' | translate }}</h2>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
              <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                         text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
              <dx-button (onClick)="deleteUserReport()" *ngIf="!isEditMode" icon="trash"
                         text="{{'BUTTONS.DELETE' | translate}}"
                         type="danger"></dx-button>
              <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button (onClick)="openImportPopup()" [type]="'default'" icon="download"
                           text="{{'DASHBOARD.REPORTS.IMPORT_FROM_CHART' | translate}}"></dx-button>
                <dx-button (onClick)="saveUserReport()"
                           [stylingMode]="'contained'"
                           [type]="'default'" icon="save"
                           text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                <dx-button
                  (onClick)="disableEditMode()" [type]="'normal'" [stylingMode]="'contained'" icon="revert"
                  text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
              </div>
              <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                         [width]="30"
                         icon="close"></dx-button>
            </div>
          </div>

          <!------------------>
          <!--  Form        -->
          <!------------------>

          <app-user-report-form
            *ngIf="isDrawerOpen && !!selectedReport"
            [report]="selectedReport"
            [disabled]="!isEditMode"
            style="overflow: hidden"
            class="flexFill">
          </app-user-report-form>

          <dx-popup
            *ngIf="isImportPopupVisible"
            [visible]="true"
            [showTitle]="true"
            [title]="'DASHBOARD.REPORTS.IMPORT_FROM_CHART' | translate"
            [dragEnabled]="false"
            [focusStateEnabled]="false"
            (onHidden)="isImportPopupVisible = false"
            [hideOnOutsideClick]="true"
            [showCloseButton]="false"
            [width]="400"
            [height]="350">
            <dxi-toolbar-item location="after" toolbar="bottom">
              <dx-button (onClick)="confirmImport()"
                         [disabled]="!selectedChartId || isImportLoading"
                         [height]="40" icon="save"
                         text="{{ 'DASHBOARD.REPORTS.IMPORT_CONFIRM' | translate }}"
                         type="default"></dx-button>
            </dxi-toolbar-item>
            <dxi-toolbar-item location="after" toolbar="bottom">
              <dx-button (onClick)="isImportPopupVisible = false"
                         [height]="40" [stylingMode]="'outlined'"
                         icon="close"
                         text="{{ 'BUTTONS.CANCEL' | translate }}"></dx-button>
            </dxi-toolbar-item>
            <div style="display: flex; flex-direction: column; gap: 16px; padding: 8px 0">
              <div *ngIf="(selectedReport?.metrics?.length ?? 0) > 0">
                <span style="color: var(--keton-alarm-offline); font-size: 14px;">
                  {{ 'DASHBOARD.REPORTS.IMPORT_OVERWRITE_WARNING' | translate }}
                </span>
              </div>
              <dx-select-box
                [dataSource]="chartList"
                displayExpr="name"
                valueExpr="id"
                [(value)]="selectedChartId"
                [placeholder]="'PLACEHOLDERS.SELECT' | translate">
              </dx-select-box>
              <dx-check-box [(value)]="importOptions.metrics"
                            [text]="'DASHBOARD.REPORTS.IMPORT_METRICS' | translate"></dx-check-box>
              <dx-check-box [(value)]="importOptions.bucket"
                            [text]="'DASHBOARD.REPORTS.IMPORT_BUCKET' | translate"></dx-check-box>
              <dx-check-box [(value)]="importOptions.name"
                            [text]="'DASHBOARD.REPORTS.IMPORT_NAME' | translate"></dx-check-box>
            </div>
          </dx-popup>

        </div>

        <!-------------------->
        <!--  Page content  -->
        <!-------------------->

        <div class="drawerOuterContent">

          <dx-data-grid
            (onRowClick)="onRowClick($event.data)"
            [columnAutoWidth]="true"
            [dataSource]="userReports"
            [showBorders]="true"
            [showRowLines]="false"
            [wordWrapEnabled]="true"
            height="100%"
            keyExpr="id">

            <dxo-scrolling mode="virtual" [rowRenderingMode]="'virtual'"></dxo-scrolling>

            <dxo-selection
              [mode]="'single'"
              [selectByClick]="true"
              [showCheckBoxesMode]="'none'">
            </dxo-selection>

            <dxo-toolbar>
              <dxi-item location="before">
                <p style="font-size: 22px; margin: 0 0 0 10px; white-space: nowrap;">{{ 'MENU_VOICE.DASHBOARD.REPORTS' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel"></dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewReportForm()"
                             hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-paging [enabled]="false"></dxo-paging>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}"></dxo-search-panel>

            <dxi-column caption="{{ 'DASHBOARD.REPORTS.NAME' | translate }}" dataField="name"></dxi-column>
            <dxi-column caption="{{ 'DASHBOARD.REPORTS.EMAIL' | translate }}" dataField="email"></dxi-column>
            <dxi-column caption="{{ 'DASHBOARD.REPORTS.CRON' | translate }}" dataField="unixCronExpression" cellTemplate="cronTemplate" width="220"></dxi-column>
            <div *dxTemplate="let cell of 'cronTemplate'">{{ cronToHuman(cell.value) }}</div>

            <dxi-column caption="{{ 'DASHBOARD.REPORTS.METRICS_PREVIEW' | translate }}" cellTemplate="metricsPreviewTemplate"></dxi-column>

            <dxi-column caption="{{ 'DASHBOARD.REPORTS.ENABLED' | translate }}" dataField="enabled"></dxi-column>

            <div *dxTemplate="let cell of 'metricsPreviewTemplate'">
              <ul [id]="'metrics-preview-' + cell.data.id" class="metrics-preview-list">
                <li *ngFor="let item of metricsPreviewItems(cell.data.metrics)">{{ item }}</li>
                <li *ngIf="metricsHasMore(cell.data.metrics)" class="metrics-preview-more">...</li>
              </ul>
              <dx-tooltip
                *ngIf="cell.data.metrics?.length"
                [target]="'#metrics-preview-' + cell.data.id"
                position="top"
                showEvent="dxhoverstart dxfocusin"
                hideEvent="dxhoverend dxfocusout">
                <div *dxTemplate="let _ of 'content'" class="metrics-tooltip-content">
                  <div *ngFor="let item of metricsTooltipItems(cell.data.metrics)" class="metrics-tooltip-item">{{ item }}</div>
                </div>
              </dx-tooltip>
            </div>

            <dxi-column caption="" cellTemplate="actionsTemplate" type="buttons"></dxi-column>

            <div *dxTemplate="let data of 'actionsTemplate'" style="display: flex; justify-content: center; gap: 10px">
              <i (click)="onEditReport($event, data.data)"
                 [matTooltip]="'BUTTONS.UPDATE' | translate"
                 class="dx-icon-edit custom-action-icon"></i>
              <i (click)="onExecReport($event, data.data)"
                 [matTooltip]="'BUTTONS.EXEC' | translate"
                 class="dx-icon-email custom-action-icon"></i>
              <i (click)="onDeleteReport($event, data.data)"
                 [matTooltip]="'BUTTONS.DELETE' | translate"
                 class="dx-icon-trash custom-action-icon"></i>
            </div>

          </dx-data-grid>

        </div>

      </dx-drawer>
    </div>
  </div>
</div>
